import React from "react";
import "./journal-doc.scss";

const Publishing = () => {
  return (
      <div className="editorial-board">
        <h1 className="title">Эмнэлзүйн Арьс Судлал Сэтгүүлийн Редакцийн зөвлөл</h1>
        <div className="columns">
          <div className="column">
            <div className="entry">
              <h3>Ерөнхий редактор</h3>
              <p>АУ-ны доктор, профессор</p>
              <p>Анагаахын Шинжлэх Ухааны Үндэсний Их Сургууль</p>
              <p className="name">Я.Энхтөр</p>
            </div>
            <div className="entry">
              <h3>Хариуцлагатай редактор</h3>
              <p>АУ-ны доктор</p>
              <p>Дермасолюшн Эмнэлэг</p>
              <p className="name">Б.Дашлхүмбэ</p>
            </div>
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор</p>
              <p>Сорбус Эмнэлэг</p>
              <p className="name">Х.Алтанзул</p>
            </div>
          </div>
          <div className="column">
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор</p>
              <p>Энх-Амаржин Сувилахуйн Төв</p>
              <p className="name">М.Ариунаа</p>
            </div>
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор, дэд профессор</p>
              <p>АШУҮИС</p>
              <p className="name">Б.Баасанжаргал</p>
            </div>
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор, дэд профессор</p>
              <p>АШУҮИС</p>
              <p className="name">Т.Баясгалан</p>
            </div>
          </div>
          <div className="column">
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор, дэд профессор</p>
              <p>АШУҮИС</p>
              <p className="name">Ж.Жамбалдорж</p>
            </div>
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны доктор</p>
              <p>ХАДА Арьс гоо заслын эмнэлэг</p>
              <p className="name">Б.Рэнцэнханд</p>
            </div>
            <div className="entry">
              <h3>Редактор</h3>
              <p>АУ-ны магистр</p>
              <p>Арьс Судлаачдын Монголын Нийгэмлэг</p>
              <p className="name">А.Нямдарь</p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Publishing;
  